import { render } from "./jointDrawer.vue?vue&type=template&id=65e647a7"
import script from "./jointDrawer.vue?vue&type=script&lang=js"
export * from "./jointDrawer.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__